module.exports = __webpack_public_path__ + "00ffe18609767fb2669cc21b5c6c9087.png";


//////////////////
// WEBPACK FOOTER
// ./image/invert_activ.png
// module id = 120
// module chunks = 0